import { DepoCikisIslemiPage } from './../../depo-cikis-islemi/depo-cikis-islemi';
import { CariStokSecimPage } from './../../cari-stok-secim/cari-stok-secim';
import { CarismsgonderPage } from './../carismsgonder/carismsgonder';
// import { CallNumber } from '@ionic-native/call-number';
import { CariHareketleriPage } from './../cari-hareketleri/cari-hareketleri';
import { CarialacakdekontPage } from './../carialacakdekont/carialacakdekont';
import { CariborcdekontPage } from './../cariborcdekont/cariborcdekont';
import { CariTahsilatPage } from './../../CariIslemleri/cari-tahsilat/cari-tahsilat';
import { CarieklePage } from './../cariekle/cariekle';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { CariOdemePage } from '../../cari-odeme/cari-odeme';
import { CariIslemPage } from '../cari-islem/cari-islem';
// import { SmsGonderPage } from '../../ServisKayit/sms-gonder/sms-gonder';
import { StokhareketleriPage } from '../../StokIslemleri/stokhareketleri/stokhareketleri';

/**
 * Generated class for the CarilerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-cariler',
  templateUrl: 'cariler.html',
})
export class CarilerPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];
  telno="";
  numaralar:any={};


  constructor(public navCtrl: NavController,public bllOrtak:BllOrtak,
    public ortak:Ortak,
    // public call:CallNumber,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

 

  ionViewDidLoad() {
    this.cariAra(null);
  }
  cariAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "CariListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
  console.log("carilr",this.cariListesi)
 
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  yeni() {
    let modal = this.modalCtrl.create(CarieklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  CariSil(cari) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("LogicalRef", cari.ID);

      this.bllOrtak.islem(formData, "CariSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.cariAra(null);
    })

}
CariGuncelle(kisi) {
  let modal = this.modalCtrl.create(CarieklePage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariTahsilat(kisi) {
  let modal = this.modalCtrl.create(CariTahsilatPage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariDekont(kisi){
  let modal=this.modalCtrl.create(CariborcdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
carihareketleri(kisi){
  let modal=this.modalCtrl.create(CariHareketleriPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();

}
CariAlacak(kisi){
  let modal=this.modalCtrl.create(CarialacakdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
CariOdeme(kisi){
  let modal = this.modalCtrl.create(CariOdemePage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariStokHareketleri(kisi)
{
  let modal = this.modalCtrl.create(StokhareketleriPage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariStokSecimPage(kisi)
{
  let modal = this.modalCtrl.create(CariStokSecimPage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
DepoCikisi(kisi)
{
  let modal = this.modalCtrl.create(DepoCikisIslemiPage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariIslemleri(kisi){
  let modal=this.modalCtrl.create(CariIslemPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
   
  });
  modal.present();
  
}
Islemler(kisi) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Cari  İşlemleri',
    buttons: [
     
      {
        text: 'Giriş Yap',
        handler:()=>{
      this.CariStokSecimPage(kisi);
        }
       
      },
      {
        text: 'Çıkış Yap',
        handler:()=>{
      this.DepoCikisi(kisi);
        }
       
      },
      //  {
      //   text: 'Cari Hareketleri',

      //   handler:()=>{
      // this.carihareketleri(kisi);
      //   }
       
      // },
      {
        text: 'Hareketler',

        handler:()=>{
      this.CariStokHareketleri(kisi);
        }
       
      },
      // {
      //   text: 'Alacak Dekontu',

      //   handler:()=>{
      //   this.CariAlacak(kisi);
      //   }
       
      // },
      {
        text: 'Borç Dekontu',

        handler:()=>{
        this.CariDekont(kisi);
        }
       
      },
      {
        text: 'Tahsilat Yap',

        handler:()=>{
        this.CariTahsilat(kisi);
        }
       
      },
      {
        text: 'Ödeme Yap',

        handler:()=>{
          this.CariOdeme(kisi);
        }
       
      },
      {
        text: 'Düzenle',
        handler: () => {
         this.CariGuncelle(kisi);
        }
      },{
        text: 'İptal ',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
  });
  actionSheet.present();
}
ara(kisi) {
  //    this.numaralar=kisi;
  //   var formData = new FormData();
  // formData.append("gidenkayit",JSON.stringify(this.numaralar));
  //   this.bllOrtak.islem(formData, "caritelnogetir", "", false).then(a => {
  //   var sonuc = <any>a;
  //     this.telno = sonuc.SonucObject;
  //       if (this.telno != null && this.telno!= '') {
  //     this.call.callNumber(this.telno, true)
  //       .then(res => console.log('Launched dialer!', res))
  //       .catch(err => console.log('Error launching dialer', err));
  //   }
  //   else {
  //     this.ortak.showBasicAlert("UYARI", "Telefon numarası boş olamaz.");
  //   }

  // })
  
}
smsgonder(kisi)
{
  let modal = this.modalCtrl.create(CarismsgonderPage, { vWKayit: kisi } );
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cariler/cariler.ts